import { Component, Input, OnInit } from '@angular/core';
import { IUbicacion } from 'modelos/src';

@Component({
  selector: 'app-polygonos',
  templateUrl: './polygonos.component.html',
  styleUrls: ['./polygonos.component.scss'],
})
export class PolygonosComponent implements OnInit {
  @Input() ubicaciones: IUbicacion[] = [];
  @Input() polygonOptions: google.maps.PolygonOptions[] = [];
  @Input() cLinea?: string;
  @Input() cRelleno?: string;
  @Input() opacidad?: number;

  constructor() { }

  createPolygons(ubicaciones: IUbicacion[]) {
    this.polygonOptions = [];
    for (let ubicacion of this.ubicaciones) {
      const polygonOptions: google.maps.PolygonOptions = {
        paths: ubicacion.poligono,
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity:
          this.opacidad || this.opacidad === 0 ? this.opacidad : 0.35,
        zIndex: -1,
        clickable: false,
        draggable: false,
        editable: false,
      };

      this.polygonOptions.push(polygonOptions);
    }
  }

  ngOnChanges() {
    this.createPolygons(this.ubicaciones);
  }

  ngOnInit(): void { }
}
